import { useCallback } from "react";
import * as yup from "yup";

const useYupValidationResolver = <T>(validationSchema: yup.Schema<T>) =>
  useCallback(
    async (data: T) => {
      try {
        const values = await validationSchema.validate(data, {
          abortEarly: false,
        });

        return {
          values,
          errors: {},
        };
      } catch (errors: unknown) {
        if (!(errors instanceof yup.ValidationError)) {
          throw errors;
        }

        return {
          values: {},
          errors: errors.inner.reduce(
            (allErrors, currentError: yup.ValidationError) => ({
              ...allErrors,
              [currentError.path as string]: {
                type: currentError.type ?? "validation",
                message: currentError.message,
              },
            }),
            {}
          ),
        };
      }
    },
    [validationSchema]
  );

export default useYupValidationResolver;
